<template>
  <v-card tile light>
    <v-toolbar
      flat
      color="grey lighten-4"
    >
      <v-btn
        icon
        color="primary"
        :disabled="disabled"
        @click.stop="cancel()"
      >
        <v-icon v-text="icons.close" />
      </v-btn>
      <v-spacer />
      <v-toolbar-title v-text="$store.state.orders.modifiers.item.name" />
      <v-spacer />
      <v-btn
        icon
        color="primary"
        :disabled="disabled"
        @click.stop="done()"
      >
        <v-icon v-text="icons.done" />
      </v-btn>
    </v-toolbar>
    <v-divider />
    <v-card-text
      ref="modifiersContainer"
      class="px-0"
    >
      <h-modifiers-stepper
        :disabled="disabled"
        @complete="completed"
      />
    </v-card-text>
  </v-card>
</template>

<script>
  import UsesIcons from '@/Mixins/UsesIcons'
  import HModifiersStepper from './Stepper'

  export default {
    mixins: [
      UsesIcons,
    ],

    components: {
      HModifiersStepper,
    },

    props: {
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    methods: {
      cancel () {
        this.close()
      },
      completed () {
        this.$emit('complete')
        this.close()
      },
      done () {
        this.$store
          .dispatch('orders/modifiers/validate', true)
          .then(success => {
            if (success) {
              this.completed()
            }
          })
      },
      close () {
        // This tiny timeout solves a bug regarding the number of modifiers
        // shown when reopening the modifiers' dialog. This issue is related to
        // the rendering of the stepper component but we do not know exactly
        // its origin.
        setTimeout(() => this.$emit('close'), 25)
        this.resetScroll()
      },
      resetScroll() {
        this.$vuetify.goTo(0, {
          container: this.$refs.modifiersContainer,
        })
      },
    },
  }
</script>
